// extracted by mini-css-extract-plugin
module.exports = {"component":"styles_component__ZD9Em"};